import { useEffect, useState } from 'react';

import { Flex, FloraButton } from '@grupoboticario/flora-react';
import {} from '@grupoboticario/flora-react';
import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { Divider, EudoraLogo, ResponsiveFloraTypography } from 'components';
import config from 'config';
import { DRAWERS, QUERYPARAMS } from 'config/environments/shared';
import { FeatureFlag } from 'domains/feature-flag.d';
import { getLongDate, getPaymentStatus } from 'helpers';
import { usePaymentDetail, useDrawer, useTracking, useFeatureFlag } from 'hooks';

import StylesDetail from './PaymentDetail.components.styles';
import Styles from '../../Drawers.styles';

export const Infos = () => {
  const [brand, setBrand] = useState(config.app.slugname);
  const { searchParams } = useDrawer(DRAWERS.PAYMENT_DETAIL);
  const { sendDataToGTM } = useTracking();
  const { data, isEudoraVdfPayment } = usePaymentDetail(
    searchParams.get(QUERYPARAMS.PAYMENT_ID) ?? ''
  );
  const isEnvironmentEudora = config.app.slugname === 'eudora';
  const { value: isVDFPaymentEnable, loading: isLoadingVDFFeatureFlag } = useFeatureFlag(
    FeatureFlag.ENABLE_VDF_PAYMENT,
    false
  );

  const handleOnClick = () => {
    const paymentStatus = getPaymentStatus({
      daysLate: data?.daysLate || 0,
      daysUntilDueDate: data?.daysUntilDueDate || 0,
      paymentStatus: data?.paymentStatus || '',
      status: data?.status || '',
    });

    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'interaction_a_pagar',
        cd_interaction_detail: `${brand}:click:ver-detalhes-do-pedido`,
        transaction_id: data?.orderId,
        cd_metodo_pagamento: data?.planDetail.toLowerCase(),
        cd_status_pagamento: paymentStatus?.tag.toLowerCase(),
        cd_dias_para_vencimento: data?.daysLate,
        cd_dias_apos_vencimento: data?.daysUntilDueDate,
      },
    });
  };

  useEffect(() => {
    if (isVDFPaymentEnable && !isLoadingVDFFeatureFlag) {
      setBrand(isEudoraVdfPayment ? 'eudora' : 'boticario');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingVDFFeatureFlag]);

  return (
    <>
      {data ? (
        <Styles.DrawerSection align='flex-start' direction='column' gap='$4'>
          <ResponsiveFloraTypography fontSize='subtitle' as='h2' fontWeight='bold'>
            Informações adicionais
          </ResponsiveFloraTypography>

          {isEudoraVdfPayment && !isEnvironmentEudora && isVDFPaymentEnable && (
            <StylesDetail.Tag>
              <EudoraLogo variant='icon' />

              <ResponsiveFloraTypography fontSize='exceptionsAuxiliar'>
                Pedido realizado em Eudora
              </ResponsiveFloraTypography>
            </StylesDetail.Tag>
          )}
          <Divider variant='Line' />
          <Styles.FullFlex direction='column' gap='$4'>
            <Flex justify='space-between'>
              <ResponsiveFloraTypography fontSize='bodySmallStandard'>
                Número do pedido
              </ResponsiveFloraTypography>
              <ResponsiveFloraTypography>{data.orderId}</ResponsiveFloraTypography>
            </Flex>
            <Flex justify='space-between'>
              <ResponsiveFloraTypography fontSize='bodySmallStandard'>
                Data da emissão
              </ResponsiveFloraTypography>
              <ResponsiveFloraTypography>{getLongDate(data.issueDate)}</ResponsiveFloraTypography>
            </Flex>

            {(!isEudoraVdfPayment || Boolean(config.app.slugname === 'eudora')) && (
              <FloraButton
                as={Link}
                isFull
                onClick={handleOnClick}
                has='iconRight'
                icon={<ArrowRightIcon />}
                size='small'
                to={`/pedido/${data.orderId}`}
                hierarchy='tertiary'
              >
                <ResponsiveFloraTypography fontSize='bodySmallShort' fontWeight='bold'>
                  Ver detalhes do pedido
                </ResponsiveFloraTypography>
              </FloraButton>
            )}
          </Styles.FullFlex>
        </Styles.DrawerSection>
      ) : null}
    </>
  );
};
